import { Form, Input, Divider, Upload, Typography } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { FlaskConical } from "lucide-react";

const { Title } = Typography;
const { Dragger } = Upload;

export default function StepLabs({ formData, onChangeField, onUploadField }) {
  const labFileList =
    (formData.labReports || []).map((file, index) => ({
      uid: `lab-${index}`,
      name: file.name,
      status: "done",
      originFileObj: file,
    })) || [];
  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
          <FlaskConical className="w-6 h-6 text-[#0B7BC1]" />
        </div>
        <Title level={4} style={{ margin: 0 }}>
          Labs
        </Title>
      </div>

      <Form.Item
        label="Upload Lab Reports (PDF, TIFF, JPG)"
        extra="PDF, TIFF, JPG (MAX. 10MB)"
      >
        <Dragger
          multiple
          accept=".pdf,.tiff,.jpg,.jpeg"
          beforeUpload={() => false}
          fileList={labFileList}
          onChange={onUploadField("labReports")}
        >
          <div className="flex flex-col justify-center items-center">
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text text-center">
              Click or drag files to this area to upload
            </p>
            <p className="ant-upload-hint text-center">
              Support for multiple lab report uploads.
            </p>
          </div>

        </Dragger>
      </Form.Item>

      <Divider>Or Enter Lab Results</Divider>

      <Form.Item label="Lab Results (Text)">
        <Input.TextArea
          placeholder="Enter lab results here..."
          value={formData.labResults}
          onChange={(e) => onChangeField("labResults", e.target.value)}
          autoSize={{ minRows: 5 }}
        />
      </Form.Item>
    </div>
  );
}

